"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shallowEqual = exports.renderSnippet = exports.getChildrenWithType = exports.getChildWithType = exports.getNamedChildrenRenderer = exports.isElementOfType = exports.hoistNonReactStatics = void 0;
const React = require("react");
const react_redux_1 = require("react-redux");
// tslint:disable-next-line:no-require-imports
exports.hoistNonReactStatics = require('hoist-non-react-statics');
const isElementOfType = (element, componentType) => {
    if (!element) {
        return false;
    }
    const { type } = element;
    if (!type || typeof type === 'string') {
        return false;
    }
    if (type.displayName && componentType.displayName) {
        return type.displayName === componentType.displayName;
    }
    return type.name === componentType.name;
};
exports.isElementOfType = isElementOfType;
function getNamedChildrenRenderer(name) {
    var _a;
    return _a = class extends React.Component {
            render() {
                return this.props.children;
            }
        },
        _a.displayName = name,
        _a;
}
exports.getNamedChildrenRenderer = getNamedChildrenRenderer;
function getChildWithType(children, type) {
    return React.Children.toArray(children).find((element) => exports.isElementOfType(element, type));
}
exports.getChildWithType = getChildWithType;
const getChildrenWithType = (children, type, maxChildCount = 1) => {
    return React.Children
        .toArray(children)
        .filter((element) => exports.isElementOfType(element, type))
        .slice(0, maxChildCount || 1);
};
exports.getChildrenWithType = getChildrenWithType;
const renderSnippet = (Component, children) => {
    if (!children) {
        return null;
    }
    return (React.createElement(Component, null, children));
};
exports.renderSnippet = renderSnippet;
exports.shallowEqual = react_redux_1.shallowEqual;
